export default __webpack_public_path__ + "static/media/splunk.6e532d27.png";